module.exports = __webpack_public_path__ + "src/app/_content/imgs/bmw/blackoil/black bmw oil image.png?58d82410fde1638d78ae75f96ccf68d5";